import React from "react";

const HelpCenter = () => {
  return (
    <div className="min-h-screen bg-black text-white font-secondary">
      <div className="max-w-5xl mx-auto px-6 py-16">
        <h1 className="font-primary text-4xl md:text-5xl mb-4">Help Center</h1>
        <p className="text-lg text-[#bfc5c5] mb-8">
          Your intelligent ally — always learning, always here.
        </p>

        <section className="mb-10">
          <p className="text-lg text-[#d0d6d6] leading-relaxed">
            At FOZZIL, we don’t just provide answers — we grow with you. Our
            Help Center is designed to evolve alongside you, offering clarity,
            confidence, and control at every step of the way.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3">
            Smart Guides, Not Just Manuals
          </h2>
          <p className="text-[#bfc5c5] mb-4">
            Step-by-step walkthroughs with live feedback, error detection, and
            adaptive learning — because real mastery comes from doing, not just
            reading. Each guide adapts to your progress and highlights next-best
            actions so you move from learning to mastery faster.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3">Context-Aware Search</h2>
          <p className="text-[#bfc5c5] mb-4">
            Ask like a human. Get answers like a mentor. Our AGI understands
            intent, context, and previous interactions — not just keywords.
            Search results surface concise solutions, relevant articles, and
            runnable examples.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3">
            Interactive Tutorials with Code Sandbox
          </h2>
          <p className="text-[#bfc5c5] mb-4">
            Learn by building. Test, break, fix — all in real time. No setup, no
            friction. Each tutorial includes editable code examples, pre-seeded
            datasets, and guided checkpoints so you can build with confidence.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3">
            Human-Backed AGI Support
          </h2>
          <p className="text-[#bfc5c5] mb-4">
            We combine fast AGI triage with human expertise when needed:
          </p>
          <ul className="list-disc list-inside text-[#bfc5c5] space-y-2">
            <li>
              <strong>Tier 1 (AGI)</strong>: Instant responses and intelligent
              routing.
            </li>
            <li>
              <strong>Tier 2 (Human Experts)</strong>: Deeper investigations and
              resolution within 2 business hours for supported plans.
            </li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-3">
            Self-Improving Knowledge Base
          </h2>
          <p className="text-[#bfc5c5] mb-4">
            Our knowledge base is self-learning: articles are continuously
            refined automatically using aggregated user behavior, engagement
            signals, and model-driven analysis so content stays current,
            accurate, and actionable. You can also submit feedback directly from
            any article to help improve it.
          </p>
        </section>

        <blockquote className="border-l-4 border-[#009df2] pl-4 italic text-[#dbe7f2] mb-8">
          “We don’t just answer questions — we anticipate them.”
        </blockquote>

        <section className="mt-8">
          <h3 className="text-xl font-semibold mb-2">Get Help</h3>
          <p className="text-[#bfc5c5]">
            Still stuck? Reach out to our support team at
            <a href="mailto:support@fozzil.in" className="underline ml-1">
              support@fozzil.in
            </a>
            . For security issues, use <strong>security@fozzil.in</strong>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default HelpCenter;
